//const apiBaseUrl = '//localhost/sarudoli-feedback/api'
const apiBaseUrl = 'https://sarudoli.axiohm.cz/api';
// const apiBaseUrl = '//localhost/api';
const CUZKbaseUrl = 'https://services.cuzk.cz/';

export { apiBaseUrl, CUZKbaseUrl };
